import { useContext } from 'react';
import { AppContext } from 'App'; // để show loading spinner

import { apiIDP } from '../../constant/apis/api';
import httpMethod from '../../services/update2025/httpMethod';

export default function useGetToken() {
    const { setLoading } = useContext(AppContext);

    const getToken = async ({ code, redirect_uri, onSuccess }) => {
        setLoading(true);
        const body = new URLSearchParams();
        body.append('code', code);
        body.append('grant_type', process.env.REACT_APP_IDP_GRAND_TYPE);
        body.append('client_id', process.env.REACT_APP_IDP_CLIENT_ID);
        body.append('redirect_uri', window.location.origin + redirect_uri);

        try {
            const res = await httpMethod.post(
                `${process.env.REACT_APP_IDP_SSO_URL}${apiIDP.GET_TOKEN}`,
                body,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            );
            if (res.status === 200) onSuccess(res.data);
        } finally {
            setLoading(false);
        }
    };

    return { getToken };
}
